import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";
import "./DeleteIndexConfirmation.css";

const DeleteIndexConfirmation = ({ onDeleteIndex, onToggleModal, indexName }) => (
  <Modal
    open
    closable={false}
    centered
    footer={null}
    onConfirm={onDeleteIndex}
    onCancel={onToggleModal}
    width="448px"
    wrapClassName="DeleteIndexConfirmation"
    className="DeleteIndexConfirmation"
  >
    <div className="docConfirmDel">
      <div className="docConfirmDelTitle DeleteIndexConfirmation--text-left">
        Delete Index &quot;
        {indexName}
        &quot;
        {" "}
      </div>
      <div className="docConfirmDelTitleMessage DeleteIndexConfirmation--text-left">All the cards stored here will also be deleted</div>
      <div className="docConfirmDelBtn">
        <Button htmlType="button" type="default" onClick={onToggleModal}>Cancel</Button>
        <Button htmlType="button" type="primary" onClick={onDeleteIndex}>Delete</Button>
      </div>
    </div>
  </Modal>
);

export default DeleteIndexConfirmation;
